<template>
  <div id="font-token-page">
    <h2>Font token</h2>
    <table class="font-table">
    <thead>
      <tr>
        <th>Token</th>
        <th>Font Display</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in fontSizes" :key="index">
        <td>{{ item.token }}</td>
        <td :class="item.class">Sample text</td>
      </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fontSizes: [
        { token: '$font-size-2xs', class: 'text-2xs' },
        { token: '$font-size-xs', class: 'text-xs' },
        { token: '$font-size-sm', class: 'text-sm' },
        { token: '$font-size-md', class: 'text-md' },
        { token: '$font-size-lg', class: 'text-lg' },
        { token: '$font-size-xl', class: 'text-xl' },
        { token: '$font-size-2xl', class: 'text-2xl' },
        { token: '$font-size-3xl', class: 'text-3xl' },
        { token: '$font-size-4xl', class: 'text-4xl' },
        { token: '$font-size-5xl', class: 'text-5xl' },
        { token: '$font-size-6xl', class: 'text-6xl' },
        { token: '$font-size-7xl', class: 'text-7xl' },
        { token: '$font-size-8xl', class: 'text-8xl' },
        { token: '$font-style-display-xl-reg', class: 'font-display-xl-reg' },
        { token: '$font-style-display-xl-med', class: 'font-display-xl-med' },
        { token: '$font-style-display-xl-bold', class: 'font-display-xl-bold' },
        { token: '$font-style-display-lg-reg', class: 'font-display-lg-reg' },
        { token: '$font-style-display-lg-med', class: 'font-display-lg-med' },
        { token: '$font-style-display-lg-bold', class: 'font-display-lg-bold' },
        { token: '$font-style-display-md-reg', class: 'font-display-md-reg' },
        { token: '$font-style-display-md-med', class: 'font-display-md-med' },
        { token: '$font-style-display-md-bold', class: 'font-display-md-bold' },
        { token: '$font-style-display-sm-reg', class: 'font-display-sm-reg' },
        { token: '$font-style-display-sm-med', class: 'font-display-sm-med' },
        { token: '$font-style-display-sm-bold', class: 'font-display-sm-bold' },
        { token: '$font-style-heading-lg-reg', class: 'font-heading-lg-reg' },
        { token: '$font-style-heading-lg-med', class: 'font-heading-lg-med' },
        { token: '$font-style-heading-lg-bold', class: 'font-heading-lg-bold' },
        { token: '$font-style-heading-md-reg', class: 'font-heading-md-reg' },
        { token: '$font-style-heading-md-med', class: 'font-heading-md-med' },
        { token: '$font-style-heading-md-bold', class: 'font-heading-md-bold' },
        { token: '$font-style-heading-sm-reg', class: 'font-heading-sm-reg' },
        { token: '$font-style-heading-sm-med', class: 'font-heading-sm-med' },
        { token: '$font-style-heading-sm-bold', class: 'font-heading-sm-bold' },
        { token: '$font-style-title-lg-reg', class: 'font-title-lg-reg' },
        { token: '$font-style-title-lg-med', class: 'font-title-lg-med' },
        { token: '$font-style-title-lg-bold', class: 'font-title-lg-bold' },
        { token: '$font-style-title-md-reg', class: 'font-title-md-reg' },
        { token: '$font-style-title-md-med', class: 'font-title-md-med' },
        { token: '$font-style-title-md-bold', class: 'font-title-md-bold' },
        { token: '$font-style-title-sm-reg', class: 'font-title-sm-reg' },
        { token: '$font-style-title-sm-med', class: 'font-title-sm-med' },
        { token: '$font-style-title-sm-bold', class: 'font-title-sm-bold' },
        { token: '$font-style-body-lg-reg', class: 'font-body-lg-reg' },
        { token: '$font-style-body-lg-med', class: 'font-body-lg-med' },
        { token: '$font-style-body-lg-bold', class: 'font-body-lg-bold' },
        { token: '$font-style-body-md-reg', class: 'font-body-md-reg' },
        { token: '$font-style-body-md-med', class: 'font-body-md-med' },
        { token: '$font-style-body-md-bold', class: 'font-body-md-bold' },
        { token: '$font-style-body-sm-reg', class: 'font-body-sm-reg' },
        { token: '$font-style-body-sm-med', class: 'font-body-sm-med' },
        { token: '$font-style-body-sm-bold', class: 'font-body-sm-bold' },
        { token: '$font-style-functional-xl-reg', class: 'font-functional-xl-reg' },
        { token: '$font-style-functional-xl-med', class: 'font-functional-xl-med' },
        { token: '$font-style-functional-xl-bold', class: 'font-functional-xl-bold' },
        { token: '$font-style-functional-lg-reg', class: 'font-functional-lg-reg' },
        { token: '$font-style-functional-lg-med', class: 'font-functional-lg-med' },
        { token: '$font-style-functional-lg-bold', class: 'font-functional-lg-bold' },
        { token: '$font-style-functional-md-reg', class: 'font-functional-md-reg' },
        { token: '$font-style-functional-md-med', class: 'font-functional-md-med' },
        { token: '$font-style-functional-md-bold', class: 'font-functional-md-bold' },
        { token: '$font-style-functional-sm-reg', class: 'font-functional-sm-reg' },
        { token: '$font-style-functional-sm-med', class: 'font-functional-sm-med' },
        { token: '$font-style-functional-sm-bold', class: 'font-functional-sm-bold' },
        { token: '$font-style-functional-xs-reg', class: 'font-functional-xs-reg' },
        { token: '$font-style-functional-xs-med', class: 'font-functional-xs-med' },
        { token: '$font-style-functional-xs-bold', class: 'font-functional-xs-bold' }
      ]
    }
  }
}
</script>

<style lang="scss">
#font-token-page {
  .font-table {
    width: 100%;
    border-collapse: collapse;
  }

  .font-table th, .font-table td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  .font-table th {
    background-color: #f4f4f4;
    font-weight: bold;
  }

  .text-2xs { font-size: $font-size-2xs; }
  .text-xs { font-size: $font-size-xs; }
  .text-sm { font-size: $font-size-sm; }
  .text-md { font-size: $font-size-md; }
  .text-lg { font-size: $font-size-lg; }
  .text-xl { font-size: $font-size-xl; }
  .text-2xl { font-size: $font-size-2xl; }
  .text-3xl { font-size: $font-size-3xl; }
  .text-4xl { font-size: $font-size-4xl; }
  .text-5xl { font-size: $font-size-5xl; }
  .text-6xl { font-size: $font-size-6xl; }
  .text-7xl { font-size: $font-size-7xl; }
  .text-8xl { font-size: $font-size-8xl; }

  .font-display-xl-reg {
    font: $font-style-display-xl-reg;
  }

  .font-display-xl-med {
    font: $font-style-display-xl-med;
  }

  .font-display-xl-bold {
    font: $font-style-display-xl-bold;
  }

  .font-display-lg-reg {
    font: $font-style-display-lg-reg;
  }

  .font-display-lg-med {
    font: $font-style-display-lg-med;
  }

  .font-display-lg-bold {
    font: $font-style-display-lg-bold;
  }

  .font-display-md-reg {
    font: $font-style-display-md-reg;
  }

  .font-display-md-med {
    font: $font-style-display-md-med;
  }

  .font-display-md-bold {
    font: $font-style-display-md-bold;
  }

  .font-display-sm-reg {
    font: $font-style-display-sm-reg;
  }

  .font-display-sm-med {
    font: $font-style-display-sm-med;
  }

  .font-display-sm-bold {
    font: $font-style-display-sm-bold;
  }

  .font-heading-lg-reg {
    font: $font-style-heading-lg-reg;
  }

  .font-heading-lg-med {
    font: $font-style-heading-lg-med;
  }

  .font-heading-lg-bold {
    font: $font-style-heading-lg-bold;
  }

  .font-heading-md-reg {
    font: $font-style-heading-md-reg;
  }

  .font-heading-md-med {
    font: $font-style-heading-md-med;
  }

  .font-heading-md-bold {
    font: $font-style-heading-md-bold;
  }

  .font-heading-sm-reg {
    font: $font-style-heading-sm-reg;
  }

  .font-heading-sm-med {
    font: $font-style-heading-sm-med;
  }

  .font-heading-sm-bold {
    font: $font-style-heading-sm-bold;
  }

  .font-title-lg-reg {
    font: $font-style-title-lg-reg;
  }

  .font-title-lg-med {
    font: $font-style-title-lg-med;
  }

  .font-title-lg-bold {
    font: $font-style-title-lg-bold;
  }

  .font-title-md-reg {
    font: $font-style-title-md-reg;
  }

  .font-title-md-med {
    font: $font-style-title-md-med;
  }

  .font-title-md-bold {
    font: $font-style-title-md-bold;
  }

  .font-title-sm-reg {
    font: $font-style-title-sm-reg;
  }

  .font-title-sm-med {
    font: $font-style-title-sm-med;
  }

  .font-title-sm-bold {
    font: $font-style-title-sm-bold;
  }

  .font-body-lg-reg {
    font: $font-style-body-lg-reg;
  }

  .font-body-lg-med {
    font: $font-style-body-lg-med;
  }

  .font-body-lg-bold {
    font: $font-style-body-lg-bold;
  }

  .font-body-md-reg {
    font: $font-style-body-md-reg;
  }

  .font-body-md-med {
    font: $font-style-body-md-med;
  }

  .font-body-md-bold {
    font: $font-style-body-md-bold;
  }

  .font-body-sm-reg {
    font: $font-style-body-sm-reg;
  }

  .font-body-sm-med {
    font: $font-style-body-sm-med;
  }

  .font-body-sm-bold {
    font: $font-style-body-sm-bold;
  }

  .font-functional-xl-reg {
    font: $font-style-functional-xl-reg;
  }

  .font-functional-xl-med {
    font: $font-style-functional-xl-med;
  }

  .font-functional-xl-bold {
    font: $font-style-functional-xl-bold;
  }

  .font-functional-lg-reg {
    font: $font-style-functional-lg-reg;
  }

  .font-functional-lg-med {
    font: $font-style-functional-lg-med;
  }

  .font-functional-lg-bold {
    font: $font-style-functional-lg-bold;
  }

  .font-functional-md-reg {
    font: $font-style-functional-md-reg;
  }

  .font-functional-md-med {
    font: $font-style-functional-md-med;
  }

  .font-functional-md-bold {
    font: $font-style-functional-md-bold;
  }

  .font-functional-sm-reg {
    font: $font-style-functional-sm-reg;
  }

  .font-functional-sm-med {
    font: $font-style-functional-sm-med;
  }

  .font-functional-sm-bold {
    font: $font-style-functional-sm-bold;
  }

  .font-functional-xs-reg {
    font: $font-style-functional-xs-reg;
  }

  .font-functional-xs-med {
    font: $font-style-functional-xs-med;
  }

  .font-functional-xs-bold {
    font: $font-style-functional-xs-bold;
  }
}
</style>
